import { render, staticRenderFns } from "./yardMerchant.vue?vue&type=template&id=690fdbc8"
import script from "./yardMerchant.vue?vue&type=script&lang=js"
export * from "./yardMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports